import React from 'react';
import GameActivitySetUpBase from '../GameActivitySetUpBase';

const FreeKickGameSetUp = (props) => <GameActivitySetUpBase {...props} />;
FreeKickGameSetUp.displayName = 'FreeKickGameSetUp';

export default React.memo(FreeKickGameSetUp);
